import { GlobalAttribute } from 'types/common';

import {
  EMAIL_HOSPITAL_URL,
  SERVER_EMAIL_SENDER,
  SERVER_FORCED_EMAIL_RECEIVER,
} from '../../../../configs/siteAndTrustAttributes';
import {
  siteAttributeKeysSubset,
  updateSiteAttributes,
} from '../SitePreferencesHooks';
import { UseEmailsPreferencesFormHooks } from './EmailsPreferencesHooks';

const keys = siteAttributeKeysSubset([
  SERVER_EMAIL_SENDER,
  SERVER_FORCED_EMAIL_RECEIVER,
  EMAIL_HOSPITAL_URL,
]);

const restAttributes: GlobalAttribute[] = keys.map((key) => ({ key }));

export const useServerSettingsFormHooks: UseEmailsPreferencesFormHooks = () => {
  return {
    restAttributes,
    beforeSubmit: (updatedSite, formValues) => {
      return {
        ...updatedSite,
        attributes: updateSiteAttributes(
          updatedSite.attributes,
          formValues.attributes,
          keys,
          (_, siteValue, formValue) => {
            return formValue || siteValue;
          },
        ),
      };
    },
  };
};
